import apiClient from "../apiClient";
const urlPath = "/api/frames/";
/**
 * Hole alle Frames von der API.
 * @returns {Promise<Array>} Eine Liste von Frames.
 */
export const fetchFrames = async () => {
  const response = await apiClient.get(urlPath);
  console.info("Fetched frames:", response.data);
  return response.data; // Erwartet eine Liste von Frames 
};

/**
 * Hole ein einzelnes Frame von der API.
 * @param {number} frameId Die ID des Frames.
 * @returns {Promise<Object>} Das Frame-Objekt.
 */
export const fetchFrameById = async (frameId) => {
  const response = await apiClient.get(`${urlPath}${frameId}/`);
  return response.data; // Erwartet ein einzelnes Frame
};

/**
 * Erstelle ein neues Frame.
 * @param {Object} frame Das Frame-Objekt, das erstellt werden soll.
 * @returns {Promise<Object>} Das erstellte Frame.
 */
export const createFrame = async (frame) => {
  const response = await apiClient.post(urlPath, frame);
  return response.data; // Erwartet das erstellte Frame
};

/**
 * Aktualisiere ein bestehendes Frame.
 * @param {number} frameId Die ID des Frames.
 * @param {Object} frame Die aktualisierten Frame-Daten.
 * @returns {Promise<Object>} Das aktualisierte Frame.
 */
export const updateFrame = async (frameId, frame) => {
  const response = await apiClient.put(`${urlPath}${frameId}/`, frame);
  return response.data; // Erwartet das aktualisierte Frame
};

/**
 * Lösche ein Frame.
 * @param {number} frameId Die ID des Frames.
 * @returns {Promise<void>} Keine Rückgabe.
 */
export const deleteFrame = async (frameId) => {
  await apiClient.delete(`${urlPath}${frameId}/`);
};